import Emittery from 'emittery';

const events = new Emittery();

export { events };
//# sourceMappingURL=events.js.map
